var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"remove-top-padding",attrs:{"max-width":"850","flat":"","color":"transparent"}},[_c('v-card-text',{staticClass:"remove-top-padding"},[_c('NewsList')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }